export default __webpack_public_path__ + "static/media/show.c84b3bef.svg";